"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Loader_1 = require("./Loader");
exports.default = Loader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Loader/index.js
// module id = 12
// module chunks = 0 1